import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const Theme = ({ theme, setTheme }) => {
    const themeArray = [
        { id: 0, theme: "light" },
        { id: 1, theme: "dark" },
    ]

    // Check if the theme value is one of the available options
    const validTheme = themeArray.find(item => item.theme === theme) ? theme : '';

    const handleChange = (event) => {
        setTheme(event.target.value);
    };

    return (
        <div>
            <FormControl size="small" fullWidth>
                <InputLabel>Theme</InputLabel>
                <Select
                    value={validTheme}
                    onChange={handleChange}
                    label="Theme"
                >
                    {themeArray.map((item) => (
                        <MenuItem key={item.id} value={item.theme}>
                            {item.theme}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    )
}

export default Theme